// extracted by mini-css-extract-plugin
module.exports = {"imgGrid":"ImageGrid_imgGrid__UItpb","imgWrap":"ImageGrid_imgWrap__xAP32"};